<template>
  <div class="app-wrapper" >
    <div class="sidebar-wrapper">
      <sidebar class="sidebar-container"></sidebar>
    </div>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>

import Navbar from '@/views/layout/Navbar'
import Sidebar from '@/views/layout/Sidebar'
import AppMain from '@/views/layout/AppMain'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import './layout.scss'
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue?71ed3654